import { MnoConfig } from '../types';

export const stagingConfig: MnoConfig = {
  id: 'berd_5',
  name: 'Life Staging',
  colors: {
    primary: '#0A69AE',  // Life blue
    secondary: '#FDCD01', // MTN Yellow
  },
  countryCode: '234',
  phoneNumberMask: '000 000 0000',
  appUrl: 'https://life-frontend-staging.1pin.com',
  locations: [
    "Abuja",
    "Abia",
    "Adamawa",
    "Akwa Ibom",
    "Anambra",
    "Bauchi",
    "Bayelsa",
    "Benue",
    "Borno",
    "Cross River",
    "Delta",
    "Ebonyi",
    "Edo",
    "Ekiti",
    "Enugu",
    "Gombe",
    "Imo",
    "Jigawa",
    "Kaduna",
    "Kano",
    "Katsina",
    "Kebbi",
    "Kogi",
    "Kwara",
    "Lagos",
    "Nasarawa",
    "Niger",
    "Ogun",
    "Ondo",
    "Osun",
    "Oyo",
    "Plateau",
    "Rivers",
    "Sokoto",
    "Taraba",
    "Yobe",
    "Zamfara",
  ],
};

